<template>
  <div>
    <div class="topbar">
      <div class="clearfix main-wrap">
        <a class="img-back pull-left" href="javascript:window.history.go(-1)">返回</a>
        <h1>{{msg}}</h1>
      </div>
      <div class="liner"></div>
    </div>



    <div class="main-page" v-bind:class="{'hide': isHideStep1}" style="padding-bottom:60px;">
      <div>
        <ul class="list-group-item tinny">
          <li class="list-group">
            <div class="liner"></div>
            <div class="clearfix  group-txt">
              <span class="pull-left">标题：</span><i class="red must pull-left">*</i>
              <div class="gray" style="margin-left:80px;"><input class="text-right font-12" style="width:100%" type="text" placeholder="点名标题" v-model="msg"></div>
            </div>
          </li>
          <li class="list-group">
            <div class="liner"></div>
            <div class="padding-15">
              <textarea class="font-14 block" placeholder="备注：" style="height:150px;" v-model="remark"></textarea>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="bottom-bar" v-bind:class="{'hide': isHideStep1}">
      <a class="button button-primary block" @click.prevent="nextStep()">下一步，编辑名单</a>
    </div>

    <div class="main-page roll-edit" v-bind:class="{'hide': !isHideStep1}" style="padding-bottom:60px;">
      <div class="topbar">
        <div class="clearfix main-wrap">
          <a class="pull-left img-back" @click.prevent="isHideStep1 = false">返回</a>
          <h1>编辑名单</h1>
          <span class="pull-right icon-right" style="color:#0cc" @click="selectAllOrCancel()">{{selectFlag}}</span>
        </div>
        <div class="liner"></div>
      </div>

      <div v-for="item in serviceList" v-if="item.list.length > 0">
        <span class="margin-15 block">{{item.typeName ? item.typeName : '未添加托管服务'}}</span>
        <ul class="list-group-item primary">
          <li class="list-group" v-for="student in item.list">
            <div class="liner"></div>
            <a class="group-link clearfix" href="javascript:;">
              <span class="pull-left img-wrap small"><img :src="item.imageAddress ? (item.baseAcessPath + item.imageAddress) : img_default" width="100%"/></span>
              <span class="group-txt" style="padding:0;height:40px;">
                <span class="block overhide">
                  <cite class="font-16 pull-left">{{student.studentName}}</cite>
                  <i class="img-sex" v-bind:class="{'boy': student.sex == '男','girl': student.sex == '女'}">{{student.sex}}</i>
                </span>
                <cite class="gray">{{(student.grade ? student.grade : '') + (student.className ? student.className : '')}}</cite>
              </span>
              <span class="pull-right checkbox-wrap">
                <i class="img-checkbox" @click="student.flag = !student.flag, selectedStudent()" v-bind:class="{'checked': student.flag}"></i>
              </span>
            </a>
          </li>
        </ul>
      </div>


    </div>

    <div class="bottom-bar" v-bind:class="{'hide': !isHideStep1}">
      <a class="button button-block button-primary" @click.prevent="setCustomCallList()">好了，生成名单</a>
    </div>
  </div>
</template>

<script>
import { service } from '../../service'
import { Toast } from 'mint-ui'
export default {
  data () {
    return {
      img_default: require('../../assets/images/img-default.png'),
      cookie_login_data: JSON.parse(window.localStorage['basic_login_data']),
      find_custom_roll_list_para: service.setPara('findCustomRollList'),
      set_custom_call_list_para: service.setPara('setCustomCallList'),
      isHideStep1: false,
      curcheId: 0,
      teacherId: 0,
      serviceList: [],
      msg: '',
      remark: '',
      studentIdList: [],
      selectFlag: '全选'
    }
  },
  mounted: function () {
    this.findCustomRollList()
  },
  methods: {
    nextStep: function () {
      if ($.trim(this.msg) == '') {
        Toast('请填写标题')
        return
      }
      this.isHideStep1 = true
    },
    findCustomRollList: function () {
      this.curcheId = this.cookie_login_data.curcheId
      this.teacherId = this.cookie_login_data.teacherId
      this.find_custom_roll_list_para.curcheId = this.curcheId

      let that = this
      let obj = {context: this, para: this.find_custom_roll_list_para, successFun: (response) => {
        that.serviceList = response.data
      }}
      service.request(obj)
    },
    selectAllOrCancel: function () { // 全选，取消全选
      for (var i = 0; i < this.serviceList.length; i++) {
        var studentList = this.serviceList[i].list
        for (var j = 0; j < studentList.length; j++) {
          if (this.selectFlag == '全选') {
            studentList[j].flag = true
          } else {
            studentList[j].flag = false
          }
        }
      }
      if (this.selectFlag == '全选') {
        this.selectFlag = '取消全选'
      } else {
        this.selectFlag = '全选'
      }
    },
    selectedStudent: function () {
      var flag = false
      for (var i = 0; i < this.serviceList.length; i++) {
        var studentList = this.serviceList[i].list
        for (var j = 0; j < studentList.length; j++) {
          if (!studentList[j].flag) {
            this.selectFlag = '全选'
            flag = true
            break
          }
        }
      }
      if (!flag) {
        this.selectFlag = '取消全选'
      }
    },
    setCustomCallList: function () {
      this.studentIdList = []
      if ($('.img-checkbox.checked').length === 0) {
        Toast('请添加学生')
        return
      } else {
        for (var i = 0; i < this.serviceList.length; i++) {
          var studentList = this.serviceList[i].list
          for (var j = 0; j < studentList.length; j++) {
            if (studentList[j].flag) {
              this.studentIdList.push(studentList[j].studentId)
            }
          }
        }
      }
      this.set_custom_call_list_para.teacherId = this.teacherId
      this.set_custom_call_list_para.curcheId = this.curcheId
      this.set_custom_call_list_para.remark = this.remark
      this.set_custom_call_list_para.msg = this.msg
      this.set_custom_call_list_para.studentIdList = JSON.stringify(this.studentIdList)

      let obj = {context: this, para: this.set_custom_call_list_para, successFun: (response) => {
        this.$router.replace('detail/' + response.data)
      }}
      service.request(obj)
    }
  }
}
</script>



// WEBPACK FOOTER //
// rollcallCustom.vue?eb331dac